import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";
import * as p from "drizzle-orm/pg-core";

// Session storage table for PostgreSQL-based authentication
export const sessions = p.pgTable(
  "sessions",
  {
    sid: p.varchar("sid").primaryKey(),
    sess: p.jsonb("sess").notNull(),
    expire: p.timestamp("expire").notNull(),
  },
  (table) => [p.index("IDX_session_expire").on(table.expire)],
);

// User storage table.
export const users = p.pgTable("users", {
  id: p.serial("id").primaryKey(),
  email: p.varchar("email").unique().notNull(),
  password: p.varchar("password").notNull(),
  firstName: p.varchar("first_name"),
  lastName: p.varchar("last_name"),
  profileImageUrl: p.varchar("profile_image_url"),
  isPremium: p.boolean("is_premium").default(false),
  createdAt: p.timestamp("created_at").defaultNow(),
  updatedAt: p.timestamp("updated_at").defaultNow(),
});

export const blogPosts = p.pgTable("blog_posts", {
  id: p.serial("id").primaryKey(),
  title: p.varchar("title").notNull(),
  excerpt: p.text("excerpt").notNull(),
  category: p.text("category"),
  author: p.varchar("author"),
  imageUrl: p.varchar("image_url"),
  blogUrl: p.varchar("blog_url"),
  createdAt: p.timestamp("created_at").defaultNow(),
  updatedAt: p.timestamp("updated_at").defaultNow(),
});

export const papers = p.pgTable("papers", {
  id: p.serial("id").primaryKey(),
  title: p.varchar("title").notNull(),
  authors: p.varchar("authors"),
  abstract: p.text("abstract"),
  pdfUrl: p.varchar("pdf_url"),
  source: p.varchar("source").notNull(),
  tags: p.text("tags").array(),
  publishedDate: p.date("published_date"),
  createdAt: p.timestamp("created_at").defaultNow(),
  updatedAt: p.timestamp("updated_at").defaultNow(),
});

export const aiTools = p.pgTable("ai_tools", {
  id: p.serial("id").primaryKey(),
  name: p.varchar("name").notNull(),
  description: p.text("description"),
  huggingFaceUrl: p.varchar("hugging_face_url"),
  category: p.varchar("category"),
  isPremium: p.boolean("is_premium").default(false),
  createdAt: p.timestamp("created_at").defaultNow(),
  updatedAt: p.timestamp("updated_at").defaultNow(),
});

export type User = typeof users.$inferSelect;
export type InsertUser = typeof users.$inferInsert;
export type LoginUser = {
  email: string;
  password: string;
};
export type RegisterUser = {
  email?: string;
  password: string;
  firstName?: string;
  lastName?: string;
};

export type BlogPost = typeof blogPosts.$inferSelect;
export type InsertBlogPost = typeof blogPosts.$inferInsert;

export type Paper = typeof papers.$inferSelect;
export type InsertPaper = typeof papers.$inferInsert;

export type AITool = typeof aiTools.$inferSelect;
export type InsertAITool = typeof aiTools.$inferInsert;

export const insertBlogPostSchema = createInsertSchema(blogPosts);
export const insertPaperSchema = createInsertSchema(papers);
export const insertAIToolSchema = createInsertSchema(aiTools);

export const loginUserSchema = z.object({
  email: z.string().email("Email inválido"),
  password: z.string().min(6, "La contraseña debe tener al menos 6 caracteres"),
});

export const registerUserSchema = z.object({
  email: z.string().optional(),
  password: z.string().min(6, "La contraseña debe tener al menos 6 caracteres"),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});
